import Consumer, { ConsumerObject } from 'consumerjs';


/**
 * Creates Members with id's.
 * @class
 */
export class MemberFactory {
    constructor() {
        this.count = 0;
    }

    /**
     * Creates a new Member object with unique id.
     * @param {object} props
     * @returns {Member}
     */
    addMember(props) {
        props.id = ++this.count;
        return new Member(props);
    }
}



/**
 * Represents a member
 * Can be passed to PriceConsumer.getPriceForMember to retrieve price information
 * @class
 */
class Member {
    /**
     * Constructor method
     * Gets called when class get instantiated
     * @param {Object} props Key/value pairs to assign to new instance
     */
    constructor(props) {
        this.id = Math.random();  // Do not rely on this.
        Object.assign(this, props);
    }

    /**
     * Returns a string representation
     */
    toString() {
        return `${this.birthdate},${this.visit},${this.id}`;
    }
}


/**
 * Represents retrieved price information
 * @class
 */
class Price extends ConsumerObject {
    get sub_total() { return `€ ${this._sub_total.toFixed(2)}`; }

    set sub_total(value) { this._sub_total = value; }

    get discount() { return (this._discount) ? `- € ${this._discount.toFixed(2)} staffelkorting` : ''; }

    set discount(value) { this._discount = value; }

    get total() { return `€ ${this._total.toFixed(2)}`; }

    set total(value) { this._total = value; }
}


/**
 * Retrieves price related information from API
 * @class
 */
export class PriceConsumer extends Consumer {
    /**
     * Constructor method
     * Gets called when class get instantiated
     * @param {string} [endpoint='/membership/prices']
     * @param {string} [objectClass=Price]
     */
    constructor(endpoint='/membership/prices/', objectClass=Price) {
        super(endpoint, objectClass);
    }

    /**
     * Retrieves the price for all members
     * @param {Member[]} members
     * @returns {Promise} promise for a Price object
     */
    getPriceForMembers(members) {
        return this.get('/', { person: members });
    }
}



// WEBPACK FOOTER //
// ./src/my_artis/js/data/membership/price.js